import React from 'react';

// Gray, gently pulsing placeholder blocks shown while live data loads, in the
// rough shape of the content that's coming (session cards, attendee rows,
// tiles). Hidden from screen readers; the wrapper announces "Loading".
export default function Skeleton({ variant = 'card', count = 3 }) {
  return (
    <div className={`portal-skel portal-skel-${variant}`} role="status" aria-label="Loading">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="portal-skel-item" aria-hidden="true">
          {variant === 'row' && <span className="portal-skel-avatar" />}
          {variant !== 'tile' && (
            <span className="portal-skel-lines">
              <span className="portal-skel-line" style={{ width: '38%' }} />
              <span className="portal-skel-line" style={{ width: '82%' }} />
              <span className="portal-skel-line" style={{ width: '61%' }} />
            </span>
          )}
        </div>
      ))}
    </div>
  );
}

// Friendly "nothing here yet" message for a section with no live data.
export function EmptyState({ children }) {
  return <div className="portal-empty">{children}</div>;
}
